module.exports = __webpack_public_path__ + "static/media/karna_10.a8d1391e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/karna/karna_10.png
// module id = 394
// module chunks = 0